import { isNullOrEmpty, validateEmail } from './util';

export default class HandlerValidation {
    static onValidation = (el, value, validations) => {
        let validate = true;
        if (typeof el === 'string') {
            validate = false;
        } else {
            if (value === undefined || value === null) {
                if (el.target.type === 'checkbox') {
                    value = el.target.checked;
                } else {
                    value = el.target.value;
                }
            }

            const isChips = el.target.classList.contains('chips');
            if (isChips) {
                validate = false;
            }
        }

        // The validation of Autocomplete and Chips are execute themselves
        if (validate === true) {
            const validationField = (el.target.attributes && 'validation-field' in el.target.attributes
                && el.target.attributes['validation-field'].nodeValue
                && el.target.attributes['validation-field'].nodeValue !== '') ? el.target.attributes['validation-field'].nodeValue : el.target.name;
            let item = validations.filter((i) => { return i.field === validationField; });
            if (item !== null && item !== undefined && item.length > 0) {
                item = item[0];
                item.isValid = true;
                item.message = '';
                item.rules.every((rule) => {
                    if ('required' in rule && rule.required === true && isNullOrEmpty(value)) {
                        item.isValid = false;
                        item.message = rule.message;
                        return false;
                    }

                    if ('minLength' in rule && rule.minLength > 0
                        && ((!isNullOrEmpty(value) && value.length < rule.minLength) || isNullOrEmpty(value))) {
                        item.isValid = false;
                        item.message = rule.message;
                        return false;
                    }

                    if ('maxLength' in rule && rule.maxLength > 0
                        && !isNullOrEmpty(value) && value.length > rule.maxLength) {
                        item.isValid = false;
                        item.message = rule.message;
                        return false;
                    }

                    if ('min' in rule && rule.min !== undefined
                        && ((!isNullOrEmpty(value) && value < rule.min) || isNullOrEmpty(value))) {
                        item.isValid = false;
                        item.message = rule.message;
                        return false;
                    }

                    if ('max' in rule && rule.max > 0
                        && !isNullOrEmpty(value) && value > rule.max) {
                        item.isValid = false;
                        item.message = rule.message;
                        return false;
                    }

                    if ('email' in rule && rule.email === true && !isNullOrEmpty(value)) {
                        if (!String(validateEmail(value))) {
                            item.isValid = false;
                            item.message = rule.message;
                            return false;
                        }
                    }

                    if ('custom' in rule && typeof rule.custom === 'function') {
                        if (!rule.custom(el, value)) {
                            item.isValid = false;
                            item.message = rule.message;
                            return false;
                        }
                    }

                    return true;
                });

                const isSelect = el.target.type.indexOf('select') >= 0;

                if (item.isValid === false) {
                    el.target.setCustomValidity(HandlerValidation.getErrorMessage(validationField, validations));

                    if (isSelect) {
                        el.target.parentNode.classList.add('invalid');
                        let element = el.target.parentNode.parentElement.getElementsByClassName('helper-text red-text')[0];
                        if (element !== null && element !== undefined) {
                            element.innerHtml = HandlerValidation.getErrorMessage(validationField, validations);
                        } else {
                            element = document.createElement('span');
                            element.setAttribute('class', 'helper-text red-text');
                            element.innerText = HandlerValidation.getErrorMessage(validationField, validations);
                            el.target.parentNode.parentElement.appendChild(element);
                        }
                    } else {
                        el.target.classList.add('invalid');
                        let element = el.target.parentElement.getElementsByClassName('helper-text')[0];
                        if (element !== null && element !== undefined) {
                            element.setAttribute('data-error', HandlerValidation.getErrorMessage(validationField, validations));
                        } else {
                            element = document.createElement('span');
                            element.setAttribute('class', 'helper-text');
                            element.setAttribute('data-error', HandlerValidation.getErrorMessage(validationField, validations));

                            el.target.parentElement.appendChild(element);
                        }
                    }
                } else {
                    el.target.setCustomValidity('');

                    if (isSelect) {
                        el.target.parentNode.classList.remove('invalid');
                        const elRemove = el.target.parentNode.parentElement.getElementsByClassName('helper-text')[0];
                        if (elRemove !== null && elRemove !== undefined) {
                            el.target.parentNode.parentElement.removeChild(elRemove);
                        }
                    } else {
                        el.target.classList.remove('invalid');
                        const elRemove = el.target.parentElement.getElementsByClassName('helper-text')[0];
                        if (elRemove !== null && elRemove !== undefined) {
                            el.target.parentElement.removeChild(elRemove);
                        }
                    }
                }
            }
        }
    }

    static getErrorMessage = (key, validations) => {
        let error = '';
        const item = validations.filter((i) => { return i.field === key; });
        if (item !== null && item !== undefined) {
            error = item[0].message;
        }
        return error;
    }
}